"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _FullscreenButton = require("./FullscreenButton");
Object.keys(_FullscreenButton).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _FullscreenButton[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function() {
            return _FullscreenButton[key];
        }
    });
});
